/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import loader from './plugins/loader'
import INIT from './modules/init'
import PURCHASE from './modules/purchase'

// ページ読み込み
import HOME from './page/home'
import ABOUT from './page/about'
import SHOP from './page/shop'

/*****
 * サイト設定
 */
window.siteinfo = {}

/*****
 * サイト初期化
 */
INIT()
loader(( request, path ) => {
  switch( path ){
    case '/': HOME(); break
    case '/about/': ABOUT(); break
    case '/shop/': SHOP(); break
  }
  switch( request ){
    case '/contact/?mode=detail&article=2': PURCHASE(); break
  }
})
